/**
 *  페이지 이름
 */
export const CS_INQUIRY_PAGE_NAME = {
  INQUIRY_DETAIL: '1:1 문의 상세',
  INQUIRY_LIST: '1:1 문의 리스트',
};

/**
 *  1:1 문의 답변 상태 이름
 */
export const CS_INQUIRY_RESPONSE_STATUS_TEXT = {
  0: '미 답변',
  1: '답변 완료',
};

/**
 *  1:1 문의 답변 상태 SELECT 리스트
 */
export const CS_INQUIRY_RESPONSE_STATUS_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '미 답변',
  },
  {
    id: 1,
    name: '답변 완료',
  },
];

/**
 *  1:1 문의 질문 유형 TEXT
 */
export const CS_INQUIRY_TYPE_TEXT = {
  0: '주문 상품 문의',
  1: '배송 관련 문의',
  2: '교환, 환불 문의',
  3: '서비스 개선사항',
  4: '서비스 칭찬',
  5: '시스템 오류 제보',
  6: '서비스 불편',
  7: '기타',
};

/**
 *  1:1 문의 질문 유형 SELECT 리스트
 */
export const CS_INQUIRY_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '주문 상품 문의',
  },
  {
    id: 1,
    name: '배송 관련 문의',
  },
  {
    id: 2,
    name: '교환, 환불 문의',
  },
  {
    id: 3,
    name: '서비스 개선사항',
  },
  {
    id: 4,
    name: '서비스 칭찬',
  },
  {
    id: 5,
    name: '시스템 오류 제보',
  },
  {
    id: 6,
    name: '서비스 불편',
  },
  {
    id: 7,
    name: '기타',
  },
];

/**
 *  1:1 문의 답변 상태에 따른 답변하기 버튼 텍스트명
 */
export const CS_INQUIRY_RESPONSE_BUTTON_TEXT = {
  /**
   *  미 답변
   */
  false: '답변 작성하기',
  /**
   *  답변 완료
   */
  true: '수정하기',
};

/**
 *  1:1 문의 작성 일자 PLACEHOLDER 텍스트
 */
export const PLACEHOLDER_TEXT_INQUIRY_CREATE_DATE = 'YYYY년 M월 D일 H시 m분 s초';

/**
 *  1:1 문의 리스트가 없을 때 보여주는 텍스트
 */
export const CS_INQUIRY_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 1:1 문의 리스트가 없습니다.';

/**
 *  1:1 문의 상세 > 최근에 주문한 주문서 정보가 없을 때 보여주는 텍스트
 */
export const CS_INQUIRY_DETAIL_LATEST_ORDER_TABLE_EMPTY_TEXT = '최근 주문한 주문서 정보가 없습니다.';

/**
 *  1:1 문의 상세 > 유저의 다른 문의 내역이 없을 때 보여주는 텍스트
 */
export const CS_INQUIRY_DETAIL_USERS_OTHER_TABLE_EMPTY_TEXT = '조회된 이 사람의 다른 문의 내역이 없습니다';

/**
 *  1:1 문의 답변 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_INQUIRY_ANSWER_TEXT = 2500;

/**
 *  1:1 문의 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_INQUIRY_MEMO_TEXT = 2500;

/**
 *  주문여부 타입
 */
export const ORDER_INQUIRY_TYPE = {
  ORDER: 0,
  NOT_ORDER: 1,
};

/**
 *  주문여부 타입 텍스트
 */
export const ORDER_INQUIRY_TYPE_TEXT = {
  [ORDER_INQUIRY_TYPE.ORDER]: '주문',
  [ORDER_INQUIRY_TYPE.NOT_ORDER]: '미주문',
};

/**
 *  주문여부 타입 SELECT LIST
 */
export const ORDER_INQUIRY_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: ORDER_INQUIRY_TYPE.ORDER,
    name: ORDER_INQUIRY_TYPE_TEXT[ORDER_INQUIRY_TYPE.ORDER],
  },
  {
    id: ORDER_INQUIRY_TYPE.NOT_ORDER,
    name: ORDER_INQUIRY_TYPE_TEXT[ORDER_INQUIRY_TYPE.NOT_ORDER],
  },
];
